import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface AlertProps {
  tone?: 'error' | 'success' | 'info';
  children: ReactNode;
  className?: string;
}

const tones = {
  error: 'border-red-500/30 bg-red-500/10 text-red-300',
  success: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300',
  info: 'border-brand-500/30 bg-brand-500/10 text-brand-200',
} as const;

export function Alert({ tone = 'info', children, className }: AlertProps) {
  return (
    <div
      // Errors interrupt; confirmations wait their turn.
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn(
        'rounded-xl border px-4 py-3.5 text-sm leading-relaxed',
        tones[tone],
        className,
      )}
    >
      {children}
    </div>
  );
}
